module.exports = __webpack_public_path__ + "fonts/material-icons.34922896.woff2";